import React, { useMemo } from 'react';
import { useCartContext } from '../Context/CartContext';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'; // ✅ Importamos useNavigate

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import "../ItemCart/Itemcart.css";
import toast, { Toaster } from 'react-hot-toast';
import { Button } from 'react-bootstrap';

const diasSemana = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];

const ItemCart = ({ items, moduloBebida, onCloseModal }) => {
  const { removeProduct } = useCartContext();
  const navigate = useNavigate(); // ✅ Hook para navegación

  console.log("Modulo de bebida:", moduloBebida);
  console.log("Lista de items en el carrito:", items);

  // **✅ Usamos useMemo para evitar que la tabla se duplique en cada render**
  const viandasAgrupadas = useMemo(() => {
    return diasSemana.reduce((acc, dia) => {
      acc[dia] = items.filter(vianda => vianda.dia_semana === dia);
      return acc;
    }, {});
  }, [items]); // Solo se recalcula cuando `items` cambia

  const notify1 = (vianda) => {
    toast.error('Combo eliminado!');
    removeProduct(vianda.id, vianda.selectedSize, vianda.acomp, vianda.selectedDrink, vianda.selectedDip);
  };

 // ✅ Función para cerrar el modal y redirigir a `/productos`
 const handleNavigate = () => {
  onCloseModal(); // Cierra el modal
  navigate('/products'); // Navega a la página de productos
};

const goToDay = (dia) => {
  // 🚀 Navegar a la página del menú si no estamos en ella
  onCloseModal(); // Cierra el modal
  navigate('/productos');

  // 🔽 Esperar un poco y luego hacer scroll al día correcto
  setTimeout(() => {
    const element = document.getElementById(`dia-${dia}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, 500); // 🔥 Esperamos 500ms para asegurarnos de que la página cargó
};

  return (
    <Container fluid className='itemCart p-3' style={{ border: "1px solid black", textAlign: "center" }}>
    <Toaster />
    <h3 className="mb-4">📅 Resumen de Viandas</h3>
    <Table bordered responsive className="text-center">
      <thead>
        <tr className="table-dark">
          <th className="text-center">Día</th>
          <th className="text-center">Viandas</th>
        </tr>
      </thead>
      <tbody>
        {diasSemana.map((dia) => (
          <tr key={dia}>
            <td className="align-middle"><b>{dia}</b></td>
            <td>
              {viandasAgrupadas[dia]?.length > 0 ? (
                viandasAgrupadas[dia].map((vianda, idx) => {
                  const drinkName = moduloBebida && vianda.selectedDrink ? vianda.selectedDrink.name : 'No seleccionado';
                  const drinkPrice = moduloBebida && vianda.selectedDrink ? vianda.selectedDrink.precio : 0;
                  const subtotal = vianda.quantity * (vianda.precio + drinkPrice);

                  return (
                    <div key={`${vianda.id}-${idx}`} className="vianda-card">
                      <Row className="align-items-center acomodo">
                        {/* <Col xs={3}>
                          <img src={vianda.image} alt={vianda.name} className="vianda-img" />
                        </Col> */}
                        <Col xs={9}>
                        <img src={vianda.image} alt={vianda.name} className="vianda-img" />
                          <p><b>{vianda.name}</b></p>
                          {moduloBebida && <p><b>Bebida:</b> {drinkName}</p>}
                          <p><b>Notas:</b> {vianda.anotaciones || 'Ninguna'}</p>
                          <p><b>Precio:</b> ${vianda.precio}</p>
                          <p><b>Subtotal:</b> ${subtotal}</p>
                          <Button variant="danger" size="sm" onClick={() => notify1(vianda)}>Eliminar</Button>
                        </Col>
                      </Row>
                    </div>
                  );
                })
              ) : (
                <div className="no-viandas">
                  <p className="text-muted">Sin viandas</p>
                  {/* ✅ Redirige a la página de productos donde está `ItemListContainer` */}
                  <Link to="/products">
                  <Button variant="primary" size="sm" onClick={() => goToDay(dia)}
                  >
                  Ver viandas disponibles</Button>
                  </Link>
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Container>
  );
};

export default ItemCart;
